import React from 'react';
import ProductInquiryCard from '../../components/ProductInquiryCard';

const AIF = () => {
  const categories = [
    {
      title: "Category I AIF — Venture Capital & Social Impact",
      badge: "Govt Incentives / Early Growth",
      desc: "Capital allocation into early-to-growth startups, social venture projects, and clean infrastructure enterprises."
    },
    {
      title: "Category II AIF — Private Equity & Structured Credit",
      badge: "Real Estate & Late Stage",
      desc: "Late-stage growth equity, pre-IPO unicorn funding rounds, distressed assets turnaround, and structured mezzanine debt."
    },
    {
      title: "Category III AIF — Hedge Funds & Long-Short Alpha",
      badge: "Market Neutral / Derivatives",
      desc: "Sophisticated long-short market neutral positions, quantitative algorithms, and index arbitrage strategies delivering absolute returns."
    }
  ];

  return (
    <div className="min-h-screen bg-[#07131F] text-slate-100 selection:bg-[#16325B] selection:text-white pb-20">
      <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 border-b border-slate-800/80 overflow-hidden text-center">
        <div className="absolute inset-0 pointer-events-none opacity-20 bg-[radial-gradient(#3B82F6_1px,transparent_1px)] [background-size:24px_24px]"></div>
        <div className="max-w-5xl mx-auto relative z-10">
          {/* <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#16325B]/40 border border-blue-500/30 text-[#60A5FA] text-xs sm:text-sm font-semibold mb-6">
            <span className="w-2 h-2 rounded-full bg-[#60A5FA] animate-pulse"></span>
            SEBI Category I, II & III Private Pools
          </div> */}
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-serif font-bold text-white tracking-tight leading-tight">
            Alternate Investment Funds <span className="text-[#60A5FA]">(AIF)</span>
          </h1>
          <p className="mt-4 text-base sm:text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
            Exclusive entry into unlisted private equity, structured debt, and absolute return long-short hedge funds for qualified family offices.
          </p>
        </div>
      </section>

      <section className="py-10 bg-[#091B2C] border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">SEBI Min. Ticket</div>
            <div className="text-2xl font-bold text-[#60A5FA] font-mono mt-1">₹1,00,00,000</div>
          </div>
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Capital Drawdown</div>
            <div className="text-2xl font-bold text-white font-serif mt-1">Tranche Calls (2–3 Yrs)</div>
          </div>
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Independent Supervision</div>
            <div className="text-2xl font-bold text-blue-300 font-serif mt-1">SEBI Custodian Monitored</div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 space-y-5">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-6">
              AIF Categorization & Mandates
            </h2>
            {categories.map((item, idx) => (
              <div
                key={idx}
                className="p-6 rounded-2xl bg-[#0B1E30]/80 backdrop-blur-sm border border-slate-700/60 hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/10 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex justify-between items-start mb-2 gap-4">
                  <h3 className="font-bold text-white text-lg sm:text-xl">{item.title}</h3>
                  <span className="text-xs px-3 py-1 bg-[#16325B]/40 text-[#60A5FA] border border-blue-500/30 rounded-full font-medium shrink-0">
                    {item.badge}
                  </span>
                </div>
                <p className="text-xs sm:text-sm text-slate-300 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="lg:col-span-5 sticky top-24">
            <ProductInquiryCard
              title="Request Private PPM"
              subtitle="Access Private Placement Memorandum (PPM), drawdown schedule, and fee architecture."
              productName="Alternate Investment Funds (AIF)"
              defaultTicket="₹1,00,00,000+"
              buttonText="Request Confidential PPM"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIF;